import { connect } from 'react-redux';
import {
  fetchLocations,
  fetchProducts,
  fetchSuppliers,
  getSupplierListOptions,
  getViewByListFetched,
  getViewByListOptions,
  setHasUnsavedChanges,
  setParams,
  setViewByList,
  setViewByListFetched,
  setWizardDetails,
} from '../../store/createNewSupplierAuthSlice';
import { getCurrentSelection } from '../../store/supplierAuthorizationSlice';

import DetailsStep from './Details';

const mapState = state => {
  const { authorizationBy, inventoryOwner, params, viewById } =
    state.loadingManagement.createNewSupplierAuth;
  const currentSelection = getCurrentSelection(state);

  return {
    authorizationBy,
    currentSelection,
    inventoryOwner,
    params,
    supplierListOptions: getSupplierListOptions(state),
    viewById,
    viewByListFetched: getViewByListFetched(state),
    viewByListOptions: getViewByListOptions(state),
  };
};

const mapDispatchToProps = {
  fetchLocations,
  fetchProducts,
  fetchSuppliers,
  setHasUnsavedChanges,
  setParams,
  setViewByList,
  setViewByListFetched,
  setWizardDetails,
};

export default connect(mapState, mapDispatchToProps)(DetailsStep);
